import { useCallback, useRef } from "react";

import { atom, useRecoilState } from "recoil";

import { readProfileList } from "Data/Profile";

import { unique } from "Functions";

const UserKeyList = atom<string[]>({
    key: 'userKeyList',
    default: [],
    dangerouslyAllowMutability: true
});

const UserObject = atom<{[userid: string]: ProfileType}>({
    key: 'userObject',
    default: {},
    dangerouslyAllowMutability: true
});

const IsLoading = atom<boolean>({
    key: "IsLoadingUser",
    default: false,
    dangerouslyAllowMutability: true,
});

export const useUsers = () => {
    const [userList, setUserList] = useRecoilState(UserKeyList);
    const [userObject, setUserObject] = useRecoilState(UserObject);

    const [isLoading, setIsLoading] = useRecoilState(IsLoading);

    const throttle = useRef(false);

    const fetch = useCallback(async (accountidlist: string[]) => {
        const newUserArray: ProfileType[] = await readProfileList(accountidlist);

        const newUserObject = Object.fromEntries(newUserArray.map(row => ([row.userid, row])));

        setUserObject(userObject => ({...userObject, ...newUserObject}));

        throttle.current = false;
        setIsLoading(throttle.current);
    }, [setIsLoading, setUserObject]);

    const secureFetch = useCallback((accountidlist: string[]) => {
        const realNewList = accountidlist.filter(Boolean).filter(id => !userList.includes(id));

        if (realNewList.length === 0) {
            return;
        }
        setUserList(userList => [...userList, ...(accountidlist.filter(Boolean))].filter(unique));

        throttle.current = true;
        setIsLoading(throttle.current);

        fetch(realNewList);

    }, [fetch, setIsLoading, setUserList, userList]);

    return {fetch: secureFetch, userObject, isLoading};
}
